import { apiConfig } from "../api/config";

/** Same-origin proxy for flaky third-party exhibition logos (.aspx redirects, etc.). */
export function proxiedMediaUrl(src: string): string {
  const s = src.trim();
  if (!s) return "";
  if (s.startsWith("data:") || s.startsWith("blob:")) return s;
  if (s.startsWith("/api/") || s.startsWith("/media/")) return s;
  if (/^https?:\/\//i.test(s)) {
    return `${apiConfig.baseUrl}/media/proxy?url=${encodeURIComponent(s)}`;
  }
  return s;
}

/**
 * Try the URL that already works on event detail (direct https),
 * then the media proxy. For http:// (mixed content) try proxy first.
 */
export function coverCandidates(src: string): string[] {
  const s = src.trim();
  if (!s) return [];
  if (
    s.startsWith("data:") ||
    s.startsWith("blob:") ||
    s.startsWith("/api/") ||
    s.startsWith("/media/")
  ) {
    return [s];
  }
  if (/^https:\/\//i.test(s)) {
    const proxied = proxiedMediaUrl(s);
    return proxied && proxied !== s ? [s, proxied] : [s];
  }
  if (/^http:\/\//i.test(s)) {
    const proxied = proxiedMediaUrl(s);
    return proxied && proxied !== s ? [proxied, s] : [s];
  }
  return [s];
}
